import {
  PadAgreementFormSubmitEvent,
  PaymentAccount,
  SelectPaymentMethodFormSubmitEventOnForwardNavigation,
  SelectPaymentMethodFormSubmitEventOnBackNavigation,
  AddPaymentMethodFormSubmitEvent,
  PaymentAccountsPushNotificationMetadata,
} from '@arc/unified-payments-frontend/shared-payment';
import { AddPaymentMethodForm } from '@arc/unified-payments-frontend/shared-payment-accounts';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PoaSelectPaymentMethodComponentActions = createActionGroup({
  source: 'POA Select Payment Method Component',
  events: {
    'Submitted Add Pad Agreement Form': props<{
      payload: PadAgreementFormSubmitEvent;
    }>(),
    'Canceled Add Pad Agreement Form': emptyProps(),
    'Payment Account Selected': props<{
      payload: PaymentAccount;
    }>(),
    'Selected Bank Account Missing Pad': emptyProps(),
    'Submitted Add Pad Form For Selected Bank Account': props<{
      payload: PadAgreementFormSubmitEvent;
    }>(),
    'Signed Pad Separately For Selected Bank Account': emptyProps(),
    'Selected Payment Account Deleted': emptyProps(),
    'Twikey Signature Failed': props<{
      payload: { paymentMethodDisplayName: string };
    }>(),
    'Step Submitted For Proceed To Review': props<{
      selectPaymentMethod: SelectPaymentMethodFormSubmitEventOnForwardNavigation;
    }>(),
    'Step Submitted For Back To Payment Details': props<{
      selectPaymentMethod: SelectPaymentMethodFormSubmitEventOnBackNavigation;
    }>(),
    'Remote Card Capture Success': props<{
      paymentAccountData: PaymentAccountsPushNotificationMetadata;
      paymentMethod: AddPaymentMethodFormSubmitEvent;
      paymentMethodForm: AddPaymentMethodForm;
    }>(),
  },
});
